module.exports = __webpack_public_path__ + "img/CMMC_levels.3a270c4d.png";